import { render } from "./UserTransactions.vue?vue&type=template&id=a9ef711a"
import script from "./UserTransactions.vue?vue&type=script&lang=js"
export * from "./UserTransactions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__